<template>
  <div class="province-box">
    <div class="filter-label">
      <img class="location-img" src="https://o.666visa.cn/static/ssqpeer/common/common-1.png">
      <div class="location-text"><slot></slot>&nbsp;-&nbsp;<div class="province-code">{{ provinces[value] }}</div></div>
      <img class="down-triangle blue-triangle" src="../../assets/imgs/product-detail/icon-down-blue.png">
      <img class="down-triangle gray-triangle" src="https://o.666visa.cn/static/ssqpeer/common/common-2.png">
    </div>
    <div class="filter-box">
      <div class="filter-item" v-for="(value, key) in provinces" :key="key">
        <span
          class="item-text"
          :class="{ 'active': value === +key }"
          @click="changeProvince(+key)"
        >{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import pcdService from '../../services/pcd-service';
import utils from '../../libs/utils';

export default{
  name: '',
  data() {
    return {
      provinces: {},
    };
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.getPcdsAndProvinces();
  },
  methods: {
    async getPcdsAndProvinces() {
      const pcds = await pcdService.getPcd();
      this.provinces = utils.extend({}, pcds[86]);
    },
    // 选择省份
    changeProvince(provinceCodeNum) {
      if (this.value === provinceCodeNum) return;
      this.$emit('input', provinceCodeNum);
    },
  },
};
</script>

<style lang="less" scoped>
.province-box {
  width: 172px;
  padding: 10px 0;
  z-index: 10;
  flex-shrink: 0;
  background-color: #fff;
  &.is-long{
    width: 200px;
  }
  .filter-label {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 16px;
    white-space: nowrap;
    position: relative;
    z-index: 11;
    &::before {
      content: "";
      width: 99%;
      display: none;
      position: absolute;
      left: 0;
      bottom: -5px;
      height: 10px;
      z-index: 2;
      background-color: white;
    }

    .location-img {
      width: 12px;
      height: 15px;
      margin-right: 6px;
    }
    .location-text {
      font-size:14px;
      line-height:14px;
      color:#2F333D;
      .province-code {
        display: inline-flex;
      }
    }
    .down-triangle {
      width: 8px;
      height: 10px;
      margin-left: 16px;
      &.blue-triangle {
        display: none;
      }
    }
  }
  .filter-box {
    display: none;
    flex-wrap: wrap;
    padding: 0 0 20px 30px;
    box-shadow:0px 2px 6px 0px rgba(0,0,0,0.12);
    width: 440px;
    position: absolute;
    right: 0;
    top: 100%;
    background-color: white;
    z-index: 1;
    .filter-item {
      display: flex;
      width: 58px;
      margin-top: 20px;
      .item-text {
        font-size:14px;
        line-height: 14px;
        font-weight:400;
        color:rgba(68,68,68,1);
        cursor: pointer;
        &:hover {
          font-weight:500;
          color:rgba(63,162,245,1);
        }
        &.active {
          font-weight:500;
          color:rgba(63,162,245,1);
        }
      }
    }
  }
  &:hover {
    box-shadow:0px 2px 6px 0px rgba(0,0,0,0.12);
    &::after{
      display: none;
    }
    .filter-label{
      .location-text {
        color: #3FA2F5;
      }
      .blue-triangle {
        display: flex;
      }
      .gray-triangle {
        display: none;
      }
    }
    .filter-box {
      display: flex;
    }
  }
  &.active{
    .filter-label {
      .blue-triangle {
        display: flex;
      }
      .gray-triangle {
        display: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/province-list-dialog.vue